import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { environment } from "@environments/environment";

// Interfaces
import { ResponseDataBase } from '@interfaces/index.interface';
import { ResourceService } from '../index.service';
import { AppConstants } from '../../appConstants';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class PortalConfigurationService {

  backURL = environment.BACKURL;
  configuration;
  loading;
  alert;
  faqs;

  private themeWrapper = document.querySelector('body');

  constructor(public http: HttpClient, public _resourceService: ResourceService,
    public translate: TranslateService, @Inject(DOCUMENT) private _document: HTMLDocument) {
    if (environment.ADMINNAVBAR.HAS && environment.ADMINNAVBAR.PORTAL_CONFIGURATION) {
      this.getPortalParameters();
    }
  }

  updatePortalParameter(portalParameter) {
    this.loading = true;
    let url = this.backURL + 'rest/resource/updateportalparameter';
    return this.http.post(url, portalParameter);
  }

  upoloadLogoFile(params) {
    this.loading = true;
    let url = this.backURL + 'rest/resource/upoloadlogofile';
    return this.http.post(url, params);
  }

  upoloadFaviconFile(params) {
    this.loading = true;
    let url = this.backURL + 'rest/resource/upoloadfaviconfile';
    return this.http.post(url, params);
  }

  getPortalParameters() {
    this.loading = true;
    let url = this.backURL + 'rest/resource/getportalparameters';
    this.http.get(url).subscribe(data => {
      let response = data as ResponseDataBase;
      this.configuration = {};
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.configuration.logoURL = response.result.filter(obj => {
          return obj.id === "LOGO_URL"
        })[0];
        this.configuration.name = response.result.filter(obj => {
          return obj.id === "FOOTER_NAME"
        })[0];
        this.configuration.address = response.result.filter(obj => {
          return obj.id === "FOOTER_ADDRESS"
        })[0];
        this.configuration.phoneNumber = response.result.filter(obj => {
          return obj.id === "FOOTER_PHONE_NUMBER"
        })[0];
        this.configuration.email = response.result.filter(obj => {
          return obj.id === "FOOTER_EMAIL"
        })[0];
        this.configuration.mainColor = response.result.filter(obj => {
          return obj.id === "PORTAL_MAIN_COLOR"
        })[0];
        this.configuration.secondaryColor = response.result.filter(obj => {
          return obj.id === "PORTAL_SECONDARY_COLOR"
        })[0];
        this.configuration.backgroundColor = response.result.filter(obj => {
          return obj.id === "PORTAL_BACKGROUND_COLOR"
        })[0];
        this.configuration.logoBackgroundColor = response.result.filter(obj => {
          return obj.id === "PORTAL_LOGO_BACKGROUND_COLOR"
        })[0];
        this.configuration.faviconURL = response.result.filter(obj => {
          return obj.id === "FAVICON_URL"
        })[0];
        this._document.getElementById('appFavicon').setAttribute('href', this.configuration.faviconURL.name);
        this.themeWrapper.style.setProperty('--main-color', this.configuration.mainColor.name);
        this.themeWrapper.style.setProperty('--secondary-color', this.configuration.secondaryColor.name);
        this.themeWrapper.style.setProperty('--background-color', this.configuration.backgroundColor.name);
        this.themeWrapper.style.setProperty('--logo-background-color', this.configuration.logoBackgroundColor.name);
        this.configuration.maxMonthsSearch = response.result.filter(obj => {
          return obj.id === "MAX_MONTHS_FREESLOTS_SEARCH"
        })[0];
        this.configuration.percentageFreeslotsShowed = response.result.filter(obj => {
          return obj.id === "PERCENTAGE_FREESLOTS_SHOWED"
        })[0];
        this.configuration.loginAttempsBeforeBlock = response.result.filter(obj => {
          return obj.id === "LOGIN_ATTEMPS_BEFORE_BLOCK"
        })[0];
        this.configuration.tokenTimeoutMinutes = response.result.filter(obj => {
          return obj.id === "TOKEN_TIMEOUT_MINUTES"
        })[0];
        this.configuration.pinExpirationDays = response.result.filter(obj => {
          return obj.id === "PIN_EXPIRATION_DAYS"
        })[0];
        this.configuration.maintenanceMode = response.result.filter(obj => {
          return obj.id === "MAINTENANCE_MODE"
        })[0];
        this.configuration.textOnMaintenanceMode = response.result.filter(obj => {
          return obj.id === "TEXT_ON_MAINTENANCE_MODE"
        })[0];
        this.configuration.messageInPortal = response.result.filter(obj => {
          return obj.id === "MESSAGE_IN_PORTAL"
        })[0];
        this.configuration.textOnMessageInPortal = response.result.filter(obj => {
          return obj.id === "TEXT_ON_MESSAGE_IN_PORTAL"
        })[0];
        this.configuration.usersForMaintenanceMode = response.result.filter(obj => {
          return obj.id === "USERS_FOR_MAINTENANCE_MODE"
        })[0];
        this.loading = false;
      }
    });
  }

  getFaqs() {
    this.loading = true;
    let url = this.backURL + 'rest/resource/getfaqs';
    this.http.get(url).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.faqs = response.result;
      }
      this.loading = false;
    });
  }

  addFaq(params) {
    this.loading = true;
    let url = this.backURL + 'rest/resource/addfaq';
    return this.http.post(url, params)
  }

  updateFaq(params) {
    console.log(params);
    this.loading = true;
    let url = this.backURL + 'rest/resource/updatefaq';
    return this.http.post(url, params)
  }

  deleteFaq(params) {
    this.loading = true;
    let url = this.backURL + 'rest/resource/deletefaq';
    return this.http.delete(url, { params: params })
      .pipe(map(res => {
        return res;
      }));
  }

}
